import React from 'react';
import Chevron from './Chevron';

const Controls = ({ currentSlide, imagesAmount, handleSlide }) => {
  const handleChevronClick = (dir) => handleSlide(dir);

  const indicatorText = `${currentSlide} / ${imagesAmount}`;

  const isLeftEnabled = currentSlide !== 1;
  const isRightEnabled = currentSlide !== imagesAmount;

  return (
    <div className="indicator__text">
      <Chevron
        direction="left"
        onClick={handleChevronClick}
        isEnabled={isLeftEnabled}
      />
      <span className="text">{indicatorText}</span>
      <Chevron
        direction="right"
        onClick={handleChevronClick}
        isEnabled={isRightEnabled}
      />
    </div>
  );
};

export default Controls;
